import React from 'react'
import { LPPromoVideoSection } from '../../api/Types'
import YouTube from '../../../views/home/machine_builder/Youtube'
import DynamicCallToAction from '../common/DynamicCallToAction'
import LandingPageSectionWrapper from '../common/LandingPageSectionWrapper'

const LandingPagePromoVideo: React.FunctionComponent<LPPromoVideoSection> = ({
  title,
  subtitle,
  youTubeId,
  cta,
  style,
}) => {
  return (
    <LandingPageSectionWrapper cssNamespace='promo-video-section' style={style}>
      {title && <h2>{title}</h2>}
      {subtitle && <p>{subtitle}</p>}
      {youTubeId && (
        <div className='promo-video-youtube'>
          <YouTube video={`https://www.youtube.com/embed/${youTubeId}`} />
        </div>
      )}
      {cta && (
        <div className='promo-video-cta'>
          <DynamicCallToAction cta={cta} />
        </div>
      )}
    </LandingPageSectionWrapper>
  )
}

export default LandingPagePromoVideo
